// Filtros de página na barra superior. Qualquer página com filtros (dashboard, listas de parceiros e
// tarefas, tarefas do parceiro) registra aqui quantos estão aplicados; o Layout mostra o funil com a
// contagem e, ao clicar, pede para a página abrir o painel. Padrão definido pelo dono em 2026-09-15:
// filtro de tabela fica na barra superior, nunca num botão dentro da página.
export const PAGE_FILTERS_REQUEST_EVENT = "flamex:page-filters-request";
export const PAGE_FILTERS_STATE_EVENT = "flamex:page-filters-state";

// Último estado publicado. A página (filho) publica ANTES de o Layout (pai) começar a escutar —
// efeitos de filho rodam antes dos do pai. O Layout lê o valor daqui ao assinar.
let lastState = { visible: false, count: 0 };

function dispatch(name, detail) {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new CustomEvent(name, { detail }));
}

export function getPageFiltersState() {
  return lastState;
}

export function publishPageFiltersState(state) {
  lastState = { visible: true, count: Number(state?.count) || 0 };
  dispatch(PAGE_FILTERS_STATE_EVENT, lastState);
}

export function clearPageFiltersState() {
  lastState = { visible: false, count: 0 };
  dispatch(PAGE_FILTERS_STATE_EVENT, lastState);
}

export function requestPageFiltersOpen() {
  dispatch(PAGE_FILTERS_REQUEST_EVENT, { open: true });
}
